
// 账号验证
let accountValidator = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请输入账号'));
    }
    return callback()
}

// 密码验证
let passwordValidator = (rule, value, callback) => {

    if (!value) {
        return callback(new Error('请输入密码'));
    }

    // if (!publicVar.PASSWOED.test(value)) {
    //     return callback(new Error('请输入正确的密码'));
    // }
    return callback()
}


const validator = {
    accountValidator,
    passwordValidator
}

export default validator
